export const ANALYTICS_EVENTS = {
  LANDING_PAGE_VISIT: 'LANDING_PAGE_VISIT',
  LANDING_PAGE_CLICK_SIGNUP: 'LANDING_PAGE_CLICK_SIGNUP',
  SIGNUP_PAGE_VISIT: 'SIGNUP_PAGE_VISIT',
  SIGNUP_PAGE_SUBMIT: 'SIGNUP_PAGE_SUBMIT',
} as const;

export const ANALYTICS_EVENT_TYPE = {
  WISH_LOCAL_WEB_EVENTS: 1,
} as const;
